import { Theme, Tooltip } from "@material-ui/core";
import React from "react";
import dataGridFields from "../../common/data-grid-fields";
import HistoryIcon from "@material-ui/icons/History";
import { useTranslate } from "react-admin";
import { useTheme } from "@material-ui/styles";

export const DriverNoViolationsField = (props: any) => {
  const translate = useTranslate();
  const theme: Theme = useTheme();
  return (
    <dataGridFields.ColoredField
      className="centered-content"
      color={() => theme.palette.success.main}
      backgroundColor={() => "auto"}
      source="violations">
      <Tooltip
        title={translate("resources.drivers.labels.driverDidntHaveViolations")}>
        <HistoryIcon style={{ color: theme.palette.success.main }} />
      </Tooltip>
    </dataGridFields.ColoredField>
  );
};
